<template>
  <el-row v-loading="loading">
    <div ref="filtersBlock">
      <el-row class="padding_5px_top padding_10px_bottom">
        <el-col style="width: 410px;">
          <el-col
            :span="5"
            class="fundSelector_tab"
          >
            基金公司：
          </el-col>
          <el-col
            :span="15"
            class="left_text_align"
          >
            <el-select
              class="fundSelector_Company"
              v-model="company"
              filterable
              clearable
              placeholder="请选择或输入公司首拼、关键字"
              :filter-method="fiterCompany"
            >
              <el-option
                v-for="item in filteredCompanyList"
                :key="item.companyName"
                :label="item.companyName"
                :value="item.companyName"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col style="width: 420px;">
          <el-col
            :span="4"
            class="fundSelector_tab"
          >
            关键字：
          </el-col>

          <el-col
            :span="15"
            class="left_text_align"
          >
            <el-input
              v-model="keyword"
              placeholder="请输入基金代码或基金名称"
            ></el-input>
          </el-col>

        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row>
        <el-col
          class="fundSelector_tab"
          :span="3"
        >
          风险等级：
        </el-col>
        <el-col
          :span="21"
          class="fundSelector_item"
        >
          <el-checkbox-group v-model="chkRisks">
            <el-checkbox
              class="funSelecter_item_col1 el-checkbox_overwrite el-new-class1"
              label="1"
            >低风险(R1)</el-checkbox>
            <el-checkbox
              class="funSelecter_item_col2 el-checkbox_overwrite el-new-class2"
              label="2"
            >中低风险(R2)</el-checkbox>
            <el-checkbox
              class="funSelecter_item_col3 el-checkbox_overwrite el-new-class3"
              label="3"
            >中风险(R3)</el-checkbox>
            <el-checkbox
              label="4"
              class="el-checkbox_overwrite el-new-class4"
            >中高风险(R4)</el-checkbox>
            <el-checkbox
              label="5"
              class="el-checkbox_overwrite"
            >高风险(R5)</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-row>
        <el-col
          class="fundSelector_tab"
          :span="3"
        >
          上期比较：
        </el-col>

        <el-col
          :span="21"
          class="fundSelector_item"
        >
          <el-checkbox-group
            v-model="chkCompares"
            :max="2"
          >
            <el-checkbox
              class="funSelecter_item_col1 el-checkbox_overwrite el-new-class1"
              label="相同"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col2 el-checkbox_overwrite el-new-class2"
              label="上升"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col3 el-checkbox_overwrite el-new-class3"
              label="下降"
            ></el-checkbox>
            <el-checkbox
              label="新增"
              class="el-checkbox_overwrite"
            ></el-checkbox>
          </el-checkbox-group>
        </el-col>

      </el-row>

            <el-row>
        <el-col
          class="fundSelector_tab"
          :span="3"
        >
          管理人信息比较：
        </el-col>

        <el-col
          :span="21"
          class="fundSelector_item"
        >
          <el-checkbox-group
            v-model="chkCompanyCompares"
          >
            <el-checkbox
              class="funSelecter_item_col1 el-checkbox_overwrite el-new-class1"
              label="低于"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col2 el-checkbox_overwrite el-new-class2"
              label="相同"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col3 el-checkbox_overwrite el-new-class3"
              label="高于"
            ></el-checkbox>
            <el-checkbox
              label="暂缺"
              class="el-checkbox_overwrite"
            ></el-checkbox>
          </el-checkbox-group>
        </el-col>

        <el-col
          class="fundSelector_tab"
          :span="3"
        >
          特殊标签：
        </el-col>
        <el-col
          :span="21"
          class="fundSelector_item"
        >
          <el-checkbox-group
            v-model="chkCompanyCompares"
          >
            <el-checkbox
              class="funSelecter_item_col1 el-checkbox_overwrite el-new-class1"
              label="主投北交所/股票"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col2 el-checkbox_overwrite el-new-class2"
              label="主投科创板/创业板"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col3 el-checkbox_overwrite el-new-class3"
              label="QDII"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col4 el-checkbox_overwrite el-new-class4"
              label="发起式基金"
            ></el-checkbox>
            <el-checkbox
              class="funSelecter_item_col5 el-checkbox_overwrite el-new-class5"
              label="持有期/定开基金"
            ></el-checkbox>
            <el-checkbox
              label="北上基金"
              class="el-checkbox_overwrite"
            ></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-row>
        <el-col
          class="fundSelector_tab"
          style="width: 12.53%;"
          :span="4"
        >
          不显示已终止基金：
        </el-col>
        <el-col
          :span="20"
          class="fundSelector_item"
        >          
            <el-checkbox v-model="chkStatus"
              class="funSelecter_item_col1 el-checkbox_overwrite"
            ></el-checkbox>          
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row style="height:105px;">
        <el-col
          class="fundSelector_tab"
          :span="3"
        >
          基金类型：
        </el-col>
        <el-col
          :span="21"
          class="fundSelector_item"
        >
          <el-checkbox-group v-model="chkTypes">
            <el-row>
              <el-checkbox
                class="fundSelector_fundType_col1 el-checkbox_overwrite el-new-class1"
                label="股票型"
              ></el-checkbox>
              <el-checkbox
                class="fundSelector_fundType_col2 el-checkbox_overwrite el-new-class2"
                label="混合型"
              ></el-checkbox>
              <el-checkbox
                class="fundSelector_fundType_col3 el-checkbox_overwrite el-new-class3"
                label="可转债"
              ></el-checkbox>
              <el-checkbox
                class="fundSelector_fundType_col4 el-checkbox_overwrite"
                label="债券型"
              ></el-checkbox>
            </el-row>
            <el-row>
              <el-checkbox
                class="fundSelector_fundType_col1 el-checkbox_overwrite el-new-class1"
                label="货币型"
              ></el-checkbox>
              <el-checkbox
                class="fundSelector_fundType_col2 el-checkbox_overwrite el-new-class2"
                label="另类"
              ></el-checkbox>
              <el-checkbox
                class="fundSelector_fundType_col3 el-checkbox_overwrite el-new-class3"
                label="商品"
              ></el-checkbox>
              <el-checkbox
                class="fundSelector_fundType_col4 el-checkbox_overwrite"
                label="其它"
              ></el-checkbox>
            </el-row>
          </el-checkbox-group>
        </el-col>

      </el-row>

      <el-divider></el-divider>
      <el-row style="line-height: 40px">
        <el-col
          :span="2"
          class="left_text_align"
        >
          <el-button
            @click="search()"
            type="primary"
          >查询</el-button>
        </el-col>
        <el-col
          :span="2"
          class="left_text_align"
        >
          <el-button
            @click="reset()"
            type="primary"
          >重置</el-button>
        </el-col>
        <el-col
          :span="20"
          class="right_text_align"
        >
          <el-link
            @click="hiddenFilters()"
            :underline="false"
          ><span class="padding-right-5-important">隐藏条件</span>
            <el-button
              icon="el-icon-arrow-up"
              circle
            ></el-button>
          </el-link>

        </el-col>
      </el-row>
    </div>
    <div
      style="display:none;height:30px;line-height:40px;"
      ref="filtersSwitch"
    >
      <el-col
        :span="24"
        class="right_text_align"
      >
        <el-link
          @click="showFilters()"
          :underline="false"
        ><span class="padding-right-5-important">显示条件</span>
          <el-button
            icon="el-icon-arrow-down"
            circle
          ></el-button>
        </el-link>
      </el-col>
    </div>

    <el-row class="margin-top-20">
      <el-table
        :data="tableData"
        @sort-change="sortChange"
        :default-sort="{ prop: 'defaultSymbol', order: 'descending' }"
        style="width: 100%;"
        class="tableSpecial"
      >
        <el-table-column
          fixed
          sortable="custom"
          prop="defaultSymbol"
          label="基金代码"
          width="105"
        ><template slot-scope="scope">
            <el-button
              @click="
                            redirectRiskLevelDataBase(scope.row.defaultSymbol)
                        "
              type="text"
              size="small"
            >{{ scope.row.defaultSymbol }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="className"
          label="基金名称"
          min-width="10%"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="10%"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="specialCategory"
          label="基金类型"
          min-width="7%"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="totalRisk"
          label="最新风险等级"
          min-width="7%"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="comparePreTotalRisk"
          label="与上期比较"
          align="left"
          min-width="6%"
        >
          <template slot-scope="scope">
            <span class="margin-left-20-important">{{ scope.row.comparePreTotalRisk | fillNull }}<i
                v-if="scope.row.comparePreTotalRisk == '下降'"
                class="el-icon-bottom iconBottom"
              ></i><i
                v-if="scope.row.comparePreTotalRisk == '上升'"
                class="el-icon-top iconTop"
              ></i></span>
          </template>
        </el-table-column>

        <el-table-column
          label="管理人公布信息"
          align="center"
        >
          <el-table-column
            sortable="custom"
            prop="totalRiskCompanyLevel"
            label="风险评级"
            align="center"
            min-width="5%"
          >
            <template slot-scope="scope">
              {{ scope.row.totalRiskCompanyLevel | fillNull }}
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="lastUpdateCompanyLevel"
            label="更新时间"
            min-width="5%"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.lastUpdateCompanyLevel | replaceTime }}
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="compareTotalRiskCompanyLevel"
            label="是否低于管理人评级"
            min-width="5%"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.compareTotalRiskCompanyLevel | replaceTime }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-col class="left_text_align padding_25px_top">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="(pagination && pagination.count) || 0"
          v-if="pagination.count > 10 ? true : false"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getCompanyList, getFilter } from "../../api/suitability";
import { fiterCompany } from "./mixin/fiterCompany";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

export default {
    mixins: [fiterCompany],
    data() {
        return {
            loading: false,
            company: "",
            keyword: "",
            chkRisks: [],
            chkCompares: [],
            chkCompanyCompares: [],
            chkTypes: [],
            chkStatus: false,
            tableData: [],
            pageSize: 0,
            pagination: {
                skip: 0,
                limit: 10,
                count: 0
            },
            params: {
                sort: "DefaultSymbol",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
                company: "",
                match: "",
                risks: "",
                compares: "",
                companyCompares:"",
                types: "",
                status:false
            }
        };
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return value.replace("00:00:00.0", "");
            } else {
                return "--";
            }
        }
    },
    mounted() {
        const self = this;
        self.loadingData(self.params);
    },
    methods: {
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8"
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData() {
            const self = this;
            self.handleCompany();
            self.getData(self.params);
        },

        getData(params) {
            const self = this;
            self.loading = true;
            getFilter(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                let fundInfo = result.data.fundFilterInfo;
                                fundInfo.forEach(function(item) {
                                    let risk = item.totalRisk;
                                    switch (risk) {
                                        case 1:
                                            item.totalRisk = "低风险(R1)";
                                            break;
                                        case 2:
                                            item.totalRisk = "中低风险(R2)";
                                            break;
                                        case 3:
                                            item.totalRisk = "中风险(R3)";
                                            break;
                                        case 4:
                                            item.totalRisk = "中高风险(R4)";
                                            break;
                                        case 5:
                                            item.totalRisk = "高风险(R5)";
                                            break;
                                    }
                                    let totalRiskCompanyLevel =
                                        item.totalRiskCompanyLevel;
                                    switch (totalRiskCompanyLevel) {
                                        case 1:
                                            item.totalRiskCompanyLevel = "R1";
                                            break;
                                        case 2:
                                            item.totalRiskCompanyLevel = "R2";
                                            break;
                                        case 3:
                                            item.totalRiskCompanyLevel = "R3";
                                            break;
                                        case 4:
                                            item.totalRiskCompanyLevel = "R4";
                                            break;
                                        case 5:
                                            item.totalRiskCompanyLevel = "R5";
                                            break;
                                    }
                                });
                                self.pagination = result.pagination;
                                self.pageSize = result.pagination.count;
                                self.tableData = fundInfo;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },

        search() {
            const self = this;
            self.params.company = self.company;
            self.params.match = self.keyword;
            self.params.risks = self.chkRisks.join(",");
            self.params.compares = self.chkCompares.join(",");
            self.params.companyCompares = self.chkCompanyCompares.join(",");
            self.params.types = self.chkTypes.join(",");
            self.params.status = self.chkStatus;
            self.getData(self.params);
        },
        reset() {
            const self = this;
            self.company = "";
            self.keyword = "";
            self.chkRisks = [];
            self.chkCompares = [];
            self.chkCompanyCompares = [];
            self.chkTypes = [];
        },
        showFilters() {
            this.$refs.filtersSwitch.style.display = "none";
            this.$refs.filtersBlock.style.display = "block";
        },
        hiddenFilters() {
            this.$refs.filtersSwitch.style.display = "block";
            this.$refs.filtersBlock.style.display = "none";
        },
        redirectRiskLevelDataBase(symbol) {
            this.$emit("redirectRiskLevelDataBase", symbol);
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.getData(self.params);
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.getData(self.params);
        },
        sortChange(column, prop, order) {
            let self = this;
            if (column.order != undefined) {
                self.params.order = column.order
                    .replace("ascending", "asc")
                    .replace("descending", "desc");
                self.params.sort = column.prop;
                self.getData(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        }
    }
};
</script>
<style lang="scss">
@import "../../public/sass/components/fundSelector";
</style>
<style scoped>
/*调整checkBox的样式 begin*/
.el-checkbox_overwrite >>> .el-checkbox__inner {
    width: 24px !important;
    height: 24px !important;
}

.el-checkbox_overwrite >>> .el-checkbox__input .el-checkbox__inner::after {
    border: 2px solid #fff !important;

    box-sizing: content-box !important;
    content: "" !important;
    border-left: 0 !important;
    border-top: 0 !important;
    left: 5px !important;
    position: absolute !important;
    top: 1px !important;
    width: 8px !important;
    height: 12px !important;
    transform: rotate(45deg) scaleY(1) !important;
}
/*调整checkBox的样式 end*/

/*
.tableSpecial >>> table tr td:nth-last-child(1), 
.tableSpecial >>> table tr td:nth-last-child(2), 
.tableSpecial >>> table tr td:nth-last-child(3){
      background: #FEFDF6;
  }
  */
/*给table最后3列添加上左边的线 begin*/
.tableSpecial >>> table tr td:nth-last-child(3),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(2),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(4) {
    border-left: 1px solid #ebeef5 !important;
}
.tableSpecial >>> table tr:nth-child(1) th {
    border-top: 1px solid #ebeef5 !important;
    line-height: 32px;
}

.el-new-class1{
  margin-right: 81px;
  width: 81px;
}
.el-new-class2{
  margin-right: 109px;
  width: 55px;
}
.el-new-class3{
  margin-right: 86px;
  width: 68px;
}
.el-new-class4{
  margin-right: 82px;
  width: 81px;
}

/*给table最后3列添加上左边的线 end*/
</style>
